import { FC } from 'react'

type SearchIconProps = {}

const SearchIcon: FC<SearchIconProps> = ({}) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0775 14.0999L16.6441 16.6666M15.9033 9.65075C15.9033 13.1399 13.0841 15.9683 9.60746 15.9683C6.12996 15.9683 3.31079 13.1399 3.31079 9.65158C3.31079 6.16075 6.12996 3.33325 9.60662 3.33325C13.0841 3.33325 15.9033 6.16159 15.9033 9.65075Z"
        stroke="#2B2F33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{' '}
    </svg>
  )
}

export default SearchIcon
